<div class="join">
  <img class="img-top" src="/assets/imgs/layingheareyes.webp" />
  <img class="img-left-top" src="/assets/imgs/gwiazdki1.webp">
  <img class="img-left-bottom" src="/assets/imgs/gwiazdki2.webp">
  <img class="img-right-top" src="/assets/imgs/gwiazdki2.webp">
  <img class="img-right-middle" src="/assets/imgs/gwiazdki1.webp">
  <img class="img-right-bottom" src="/assets/imgs/wand.webp">
  <h1 class="xx-small text-center" [innerHTML]="'layout.join.title' | translate"></h1>
  <p [innerHTML]="'layout.join.subtitle' | translate"></p>
  <div class="xl:flex xl:justify-content-center">
    <div>
      <app-newsletter buttonColor="pink-dark"></app-newsletter>
      <div class="text-white sub-text hidden xl:block">
        {{ 'layout.join.privacy_note_1' | translate }} <a routerLink="privacy">{{ 'layout.join.privacy_note_2' | translate }}</a>
      </div>
    </div>
  </div>
  <div class="text-center">
    <div class="footer-text">{{ 'layout.join.no_spam' | translate }}</div>
  </div>
</div>
